import { useCallback, useMemo, useState } from 'react'

const SKIP_TOP = 2
const MAX_VISIBLE = 10

export const useExpandingStrengths = rows => {
	const [openDims, setOpenDims] = useState(() => new Set())

	const toggleDim = useCallback(dim => {
		setOpenDims(prev => {
			const next = new Set(prev)
			if (next.has(dim)) {
				next.delete(dim)
			} else {
				next.add(dim)
			}
			return next
		})
	}, [])

	return useMemo(() => {
		const filtered = (Array.isArray(rows) ? rows : [])
			.slice(SKIP_TOP)
			.filter(r => r.score > 0)
			.slice(0, MAX_VISIBLE)
		return {
			rows: filtered,
			openDims,
			toggleDim,
			total: filtered.length,
		}
	}, [rows, openDims, toggleDim])
}

export default useExpandingStrengths

